export const DEFAULT_METRES = 20; 
const metersToLng = (m, lat) => m / (111320 * Math.cos((lat * Math.PI) / 180));
const metersToLat = (m)      => m / 110540;


export const buildCoordinates = (centerLng, centerLat, widthM, heightM, rotationDeg = 0) => {
  const rad = (rotationDeg * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);

  const hw = widthM  / 2;
  const hh = heightM / 2;

  const metricCorners = [
    [-hw, +hh],  
    [+hw, +hh],  
    [+hw, -hh],  
    [-hw, -hh],  
  ];

  return metricCorners.map(([mx, my]) => {
    const rx = mx * cos - my * sin; 
    const ry = mx * sin + my * cos; 
    return [
      centerLng + metersToLng(rx, centerLat),
      centerLat + metersToLat(ry),
    ];
  });
};

export const getCenter = (coordinates) => {
  const lngs = coordinates.map((c) => c[0]);
  const lats  = coordinates.map((c) => c[1]);
  return [
    (Math.min(...lngs) + Math.max(...lngs)) / 2,
    (Math.min(...lats) + Math.max(...lats)) / 2,
  ];
};

export const getWidthMetres = (coordinates) => {
  const [lng1, lat1] = coordinates[0];
  const [lng2, lat2] = coordinates[1];
  const dx = (lng2 - lng1) * 111320 * Math.cos((lat1 * Math.PI) / 180);
  const dy = (lat2 - lat1) * 110540;
  return Math.sqrt(dx * dx + dy * dy);
};

export const translateCoordinates = (coordinates, dlng, dlat) =>
  coordinates.map(([lng, lat]) => [lng + dlng, lat + dlat]);

export const rotateCoordinates = (coordinates, newRotationDeg, aspectRatio) => {
  const [cx, cy] = getCenter(coordinates);
  const widthM   = getWidthMetres(coordinates);
  const heightM  = widthM / aspectRatio;
  return buildCoordinates(cx, cy, widthM, heightM, newRotationDeg);
};

export const resizeCoordinates = (coordinates, newWidthM, aspectRatio, rotationDeg) => {
  const [cx, cy] = getCenter(coordinates);
  const heightM  = newWidthM / aspectRatio;
  return buildCoordinates(cx, cy, newWidthM, heightM, rotationDeg);
};

export const svgToPNGDataURL = (svgText, width, height) =>
  new Promise((resolve, reject) => {
    const blob  = new Blob([svgText], { type: 'image/svg+xml' });
    const blobURL = URL.createObjectURL(blob);
    const img   = new Image();

    img.onload = () => {
      const canvas  = document.createElement('canvas');
      canvas.width  = Math.max(1, Math.round(width));
      canvas.height = Math.max(1, Math.round(height));
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(blobURL);   
      resolve(canvas.toDataURL('image/png'));
    };

    img.onerror = (err) => {
      URL.revokeObjectURL(blobURL);
      reject(new Error(`SVG rasterisation failed: ${err}`));
    };

    img.src = blobURL;
  });